import React from "react";

export default function Modal({ show, onClose, title, children }) {
  if(show) {
    document.body.classList.add("overflowHidden");
  } else {
    document.body.classList.remove("overflowHidden");
  }
  return (
    <div className={`modal${show ? " open" : ""}`}>
      <div className="content-modal-assumption">
        <div className="content-assumption-description">
          <div className="flex items-center justify-between border-b border-gray-10 pb-4 mb-6">
            <h5 className="lead text-primary-100 font-semibold pr-4">
              {title}
            </h5>
            <button
              onClick={onClose}
              className="btn-icon btn-primary btn-small"
            >
              {" "}
              <i className="icon icon-close text-[10px]"></i>
            </button>
          </div>
          <div className="block space-y-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
